export const locationMapper = (data) => ({
    id: data.id,
    name : data.name,
})